import { CarbonCreditResponse } from 'src/app/shared/interfaces/carbon-credit-request';

export type CreditRegisterSuccessFlow = 'acx' | 'cdm' | 'b3';

export type CreditRegisterSuccessAction = 'new-register' | 'consult' | 'dismiss';

export type CreditRegisterErrorAction = 'retry' | 'support' | 'dismiss';

export type CreditRegisterInfoAction = 'dismiss';

export interface CreditRegisterSuccessViewModel {
  flowType: CreditRegisterSuccessFlow;
  title: string;
  description: string;
  carbonCreditCode: string;
  sentDateLabel: string;
  statusLabel: string;
  showNextSteps: boolean;
}

export interface CreditRegisterErrorViewModel {
  title: string;
  description: string;
}

export interface CreditRegisterInfoViewModel {
  title: string;
  message: string;
  icon: string;
  iconTone: 'danger' | 'warning' | 'info';
}

function formatSentDate(date: Date): string {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

function getSuccessDescription(flowType: CreditRegisterSuccessFlow): string {
  if (flowType === 'acx') {
    return 'O Registro de Créditos de Carbono foi enviado e está aguardando confirmação do cliente na plataforma da ACX.';
  }
  if (flowType === 'cdm') {
    return 'Registro MDL enviado com sucesso.';
  }
  return 'Seu registro foi enviado com sucesso para a B3. Por favor, consulte o status do seu registro na aba "Consulta de Operações".';
}

function getSuccessStatusLabel(flowType: CreditRegisterSuccessFlow): string {
  if (flowType === 'acx') {
    return 'Aguardando confirmação na ACX';
  }
  if (flowType === 'cdm') {
    return 'Pendente Confirmação de Registro';
  }
  return 'Registro enviado';
}

export function buildCreditRegisterSuccessViewModel(
  res: CarbonCreditResponse,
  flowType: CreditRegisterSuccessFlow,
): CreditRegisterSuccessViewModel {
  return {
    flowType,
    title: 'Registro enviado para confirmação.',
    description: getSuccessDescription(flowType),
    carbonCreditCode: res.data?.carbonCreditCode ?? '',
    sentDateLabel: formatSentDate(new Date()),
    statusLabel: getSuccessStatusLabel(flowType),
    showNextSteps: flowType === 'cdm',
  };
}
